import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "./RichTextEditor.css";

const TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  [{ size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", "strike"],
  [{ color: [] }, { background: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ align: [] }],
  ["blockquote", "link"],
  ["clean"],
];

const FORMATS = [
  "header", "size",
  "bold", "italic", "underline", "strike",
  "color", "background",
  "list", "bullet",
  "align",
  "blockquote", "link",
];

/**
 * Rich-text editor producing safe HTML.
 * Usage: <RichTextEditor value={html} onChange={setHtml} placeholder="…" />
 */
export default function RichTextEditor({ value, onChange, placeholder, minHeight = 220, testId }) {
  return (
    <div className="rte-wrapper" data-testid={testId}>
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={{ toolbar: TOOLBAR, clipboard: { matchVisual: false } }}
        formats={FORMATS}
        placeholder={placeholder}
        style={{ minHeight: minHeight + "px" }}
      />
    </div>
  );
}
